import { Fragment, useEffect, useState } from "react";
import {
  SecondaryHeaderContainer,
  LeftContent,
  QuotesImgContainer,
  QuotesTitle,
  QuotesTitleContainer,
  QuotesTitleContent,
  RightContent,
  UserOrganization,
  CustomerQuoteSearchContainer,
} from "../../Quote-components/Quotes-secondary-header/quote-secondary-header-components";
import { PiSearch } from "pixel-kit";
import { getLocalStorage } from "../../../core/localStorage/localStorage";
import InvoiceIcon from "../../../assets/images/invoice-icon.svg";
export default function InvoiceSecondaryHeader({
  requestInfo,
  sendEventData,
}: any) {
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    setSearchValue(requestInfo?.searchkey ? requestInfo.searchkey : "");
  }, [requestInfo]);
  let userOrganization: any = getLocalStorage("userPermission");

  function handleKeyUp(e: KeyboardEvent) {
    const target = e.target as HTMLInputElement;
    if (e.key === 'Enter' && target.value.length >= 1) {
      sendEventData({ success: true, searchValue: target.value });
    }
  }
  function valueChanged(e: React.ChangeEvent<HTMLInputElement>) {
    const target = e.target as HTMLInputElement;
    setSearchValue(target.value);
    if (target.value.length === 0) {
      sendEventData({ success: true, searchValue: "" });
    }

  }

 
  function clearSearch() {
    setSearchValue("");
    sendEventData({ success: true, searchValue: "" });
  }

  return (
    <Fragment>
      <SecondaryHeaderContainer>
        <LeftContent>
          <QuotesTitleContainer>
            <QuotesImgContainer className="invoice">
              <img src={InvoiceIcon} alt="loading" />
            </QuotesImgContainer>
            <QuotesTitleContent>
              <QuotesTitle>{"Invoices"}</QuotesTitle>
              <UserOrganization
                title={
                  JSON.parse(userOrganization).user_organization_info.label
                }
              >
                {JSON.parse(userOrganization).user_organization_info.label}
              </UserOrganization>
            </QuotesTitleContent>
          </QuotesTitleContainer>
        </LeftContent>

        <RightContent>
          <div className="add-Icon">
            <CustomerQuoteSearchContainer>
              <PiSearch
                libraryType="atalskit"
                onClear={() => clearSearch()}
                onKeyUp={(e) => handleKeyUp(e)}
                onValueChange={(e) => valueChanged(e)}
                placeholder={"Search By Invoice / Order ID"}
                value={searchValue}
                className={"quote-search"}
              />
            </CustomerQuoteSearchContainer>
          </div>
        </RightContent>
      </SecondaryHeaderContainer>
    </Fragment>
  );
}
